import React from "react";
import styled from "styled-components";
import { breakpoint, theme } from "@utilities";

const BannerWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
    border: 1.5px solid ${theme.colors.main};
    border-radius: 12px;
    /* bannerDiscount rather than bannerPointsDesktop: the latter ends on a lilac
       that fought the new border. This one is the flavour's own pale wash — cream
       on peterpans, pale blue on freelance — so each brand stays consistent. */
    background: linear-gradient(
        90deg,
        ${theme.gradients.bannerDiscount[0]},
        ${theme.gradients.bannerDiscount[1]}
    );
    padding: 16px 12px;
    margin-top: 0;
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
    min-height: 80px;
    box-sizing: border-box;
    font-family: "Poppins";

    ${breakpoint.breakOnlyMobile`
        margin:0 16px 32px 16px;
    `}
    ${breakpoint.breakMobileMedium`
        width: ${(props) => props.theme.widths.wide_700};
    `}
    ${breakpoint.breakTablet`
        width: ${(props) => props.theme.widths.wide_700};   
    `}
    ${breakpoint.breakIpadPro`
        width: ${(props) => props.theme.widths.wide_850}; 
    `}
    ${breakpoint.breakLarge`
        width: ${(props) => props.theme.widths.wide_1110};
    `}
    ${breakpoint.breakTablet`
        padding: 16px 24px;
    `}
`;

const BannerText = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
`;

const Headline = styled.div`
    font-size: 0.875rem;
    font-weight: 600;
    color: #3c3c3c;
    margin-bottom: 4px;
`;

const Subtext = styled.div`
    font-size: 0.875rem;
    color: #6e7375;
    font-weight: 300;
`;

const LearnMore = styled.a`
    /* Black with a yellow hover, matching the Explore More links: solid yellow
       text on this near-white wash is not legible. */
    color: ${theme.colors.black};
    font-weight: 500;
    font-size: 0.875rem;
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.2s;
    &:hover {
        color: ${theme.colors.main};
        text-decoration: underline;
    }
`;

export interface PointsBannerProps {
    learnMoreHref: string;
}

export const PointsBanner: React.FC<PointsBannerProps> = ({ learnMoreHref }) => (
    <BannerWrapper>
        <img src="/images/Reward.svg" alt="Reward icon" />
        <BannerText>
            <Headline>Collect points, earn more discounts</Headline>
            <Subtext>Get discounts by your points</Subtext>
        </BannerText>
        <LearnMore href={learnMoreHref}>Learn More</LearnMore>
    </BannerWrapper>
);
